const CryptoJS = require('crypto-js');

const KEY = CryptoJS.enc.Utf8.parse('59=sec%by!obs1-Z');
const IV = CryptoJS.enc.Hex.parse('00000000000000000000000000000000');

//This is currently not used but is kept here to save headache if
//the time should ever come when we need it.
export const encryptSipInfo = (plainText) => {
    const encrypted = CryptoJS.AES.encrypt(plainText, KEY, { iv: IV });

    return encrypted.ciphertext.toString(CryptoJS.enc.Hex);
};

export const decryptSipInfo = (cipherText) => {
    const cipherParams = CryptoJS.lib.CipherParams.create({
        ciphertext: CryptoJS.enc.Hex.parse(cipherText),
    });

    const decrypted = CryptoJS.AES.decrypt(cipherParams, KEY, { iv: IV });

    return decrypted.toString(CryptoJS.enc.Utf8);
};

/**
 * Encode a UTF-8 string to base64.
 * Inspiration for both this function and base64DecodeUTF8 below was found
 * in this StackOverflow thread: https://stackoverflow.com/a/30106551.
 */
export const base64EncodeUTF8 = (str) => {
    // first we use encodeURIComponent to get percent-encoded UTF-8,
    // then we convert the percent encodings into raw bytes which
    // can be fed into btoa.
    return btoa(
        encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, (_match, p1) => {
            return String.fromCharCode('0x' + p1);
        }),
    );
};

/**
 * Decode a base64 string to UTF-8.
 */
export const base64DecodeUTF8 = (str) => {
    // Going backwards: from bytestream, to percent-encoding, to original string.
    // '00' + c.charCodeAt(0).toString(16)).slice(-2) prepends a 0 to single
    // character strings, for example, when c == \n, the c.charCodeAt(0).toString(16)
    // returns a, forcing a to be represented as 0a.
    return decodeURIComponent(
        atob(str)
            .split('')
            .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
            .join(''),
    );
};
